import React from "react";
import { Dialog as KendoDialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

const Error = (props) => {

  const CustomTitleBar = () => {
    return (
      <div
        className="custom-title"
        style={{
          fontSize: "18px",
          lineHeight: "1.3em",
          color: 'red',
        }}
      >
        {props.title}
      </div>
    );
  };

  return (
    <KendoDialog title={<CustomTitleBar />} onClose={props.onConfirm} className='flo-kendo-dialog'>
      <div style={styles.content}>
        <p style={styles.text}>
          {props.text}
        </p>
      </div>
      <DialogActionsBar layout="end">
        <button
          className="k-button k-primary"
          onClick={props.onConfirm}
          style={styles.modalBtn}
        >
          Ok
        </button>
      </DialogActionsBar>
    </KendoDialog>
  )
}

const styles = {
  content: {
    minWidth: '275px',
  },
  text: {
    color: 'red',
    margin: '10px 10px 20px 10px',
    textAlign: 'center',
    maxWidth: '350px',
  },
  modalBtn: {
    padding: '10px 15px',
  },
}

export default Error;